
























































































































import Vue from 'vue'
import Drawer from '@/components/Global/Drawer.vue'
import QrDialog from '@/components/Global/QrDialog.vue'
import { emptyEntity } from '@/components/Entities/constants'
import { mutations } from '@/state'
import { apiDeleteEntity } from '@/api'

export default Vue.extend({
  name: 'ReadOnlyEntityDrawer',
  components: { Drawer, QrDialog },
  props: {
    readOnlyEntityDrawerOpened: Boolean,
    hasCustomers: Boolean,
    entity: Object,
    dropdowns: Object
  },
  computed: {
    deleteDisabled () {
      return this.editedEntity.user_name.length > 0
    },
    showLicensePlateInput () {
      const { type } = this.editedEntity.entity_properties
      return !['eBike', 'eCargoBike'].some(t => t === type)
    }
  },
  data () {
    return {
      drawerActive: false,
      qrDialogOpened: false,
      editedEntity: { ...emptyEntity }
    }
  },
  methods: {
    close () {
      this.$emit('close')
      this.editedEntity = { ...emptyEntity }
    },
    async deleteEntity () {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmText', component: 'messages' }, this.editedEntity.name))

      if (!isConfirmed) return

      mutations.setSnackbar()
      apiDeleteEntity(this.editedEntity.id).then(() => {
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      }).finally(() => {
        this.close()
        this.$emit('resetEntities')
      })
    },
  },
  watch: {
    entity (val) {
      if (!val.id) return
      const { id, name, imei, short_name, user_name, business, business_id, subscription, entity_properties, odo, active, can_be_recovered, positioned_at, created_at, created_by_name, maintenance_plan, additional_info } = val
      const { editedEntity } = this
      editedEntity.id = id
      editedEntity.name = name
      editedEntity.imei = imei
      editedEntity.short_name = short_name
      editedEntity.user_name = user_name
      editedEntity.business = [{ name: business, id: business_id }]
      editedEntity.subscription = subscription
      editedEntity.odo = odo
      editedEntity.active = active
      editedEntity.can_be_recovered = can_be_recovered
      editedEntity.positioned_at = this.dateTimeToLocal(positioned_at)
      editedEntity.created_at = this.dateTimeToLocal(created_at)
      editedEntity.created_by_name = created_by_name
      editedEntity.business_id = business_id
      editedEntity.maintenance_plan = [maintenance_plan]
      editedEntity.maintenance_plan_id = maintenance_plan?.id || null
      editedEntity.additional_info = additional_info
      delete entity_properties.model_id
      delete entity_properties.engine_model_id
      editedEntity.entity_properties = entity_properties
      this.missingDisabled = !this.hasPermission('create:missing-entities') || !editedEntity.can_be_recovered
    },
    readOnlyEntityDrawerOpened (val) {
      this.drawerActive = val
    }
  }
})
